import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Layout from "@/components/Layout";
import ConsultantDashboard from "@/pages/ConsultantDashboard";
import CandidatePortal from "@/pages/CandidatePortal";
import CandidateAssessment from "@/pages/CandidateAssessment";
import AssessmentDetail from "@/pages/AssessmentDetail";
import Matrix from "@/pages/Matrix";
import Jobs from "@/pages/Jobs";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
    </div>
  );
}

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/app" replace />;
  return children;
}

function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (user) return <Navigate to="/app" replace />;
  return <Landing />;
}

function AppHome() {
  const { user } = useAuth();
  if (user?.role === "candidate") return <Navigate to="/app/portal" replace />;
  return <Navigate to="/app/dashboard" replace />;
}

function App() {
  return (
    <div className="App grain-overlay">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomeRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/app"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<AppHome />} />
              <Route path="dashboard" element={<Protected roles={["consultant", "admin"]}><ConsultantDashboard /></Protected>} />
              <Route path="jobs" element={<Protected roles={["consultant", "admin"]}><Jobs /></Protected>} />
              <Route path="portal" element={<Protected roles={["candidate"]}><CandidatePortal /></Protected>} />
              <Route path="assessment/new" element={<Protected roles={["candidate"]}><CandidateAssessment /></Protected>} />
              <Route path="assessment/:id" element={<AssessmentDetail />} />
              <Route path="matrix" element={<Matrix />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
